import Layout from "../components/Layout";

const JoinUs = () => {
  return (
    <Layout>
      <section className="JoinUs">
        <div className="JoinUs__Title"></div>
        <p>
          Each month of 2026, we're going to throw a little website party and
          invent a creature to attend. ALL are welcome. Click this button to
          request an account.
        </p>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSd0OuklsH8XRAqodu3g59-u3I-jR4BoHeFASeGoYStTT_9SAQ/viewform"
          target="_blank"
        >
          Request an account
        </a>
        <br />
        <br />

        <h3>Spectator Pass</h3>
        <p>
          Not ready go all-in yet? Sign up for the monthly invitation that each
          attendee gets, just as a reminder.
        </p>

        <a href="https://dashboard.mailerlite.com/forms/275371/76175007445681749/share">
          Sign up for the invite
        </a>
      </section>
    </Layout>
  );
};

export default JoinUs;
